import setup from './setup'

const track = (
  event,
  args,
  { renewSession = false, includeContext = true } = {}
) => {
  return setup().then(() => {
    window.tagular(
      'beam',
      {
        '@type': event,
        ...args,
      },
      renewSession,
      includeContext
    )
    console.log('%c @analytics/make - track', 'color: cyan', {
      event,
      ...args,
    })
  })
}

const makeTrackings = {
  pageView: (pageName) => {
    track('redventures.usertracking.v2.PageViewed', {
      pageName,
    })
  },

  elementClicked: ({
    location,
    position,
    elementType,
    text,
    htmlId,
    actionOutcome,
    outboundUrl,
  }) => {
    track('redventures.usertracking.v3.ElementClicked', {
      webElement: {
        location,
        position,
        elementType,
        text,
        htmlId,
      },
      actionOutcome,
      outboundUrl: outboundUrl ? outboundUrl : '',
    })
  },
}

export default makeTrackings
